module.exports = __webpack_public_path__ + "static/media/1274_CareTeam_bio11.ded3164c.png";